(() => {
  if (customElements.get('back-in-stock')) {
    return;
  }

  class BackInStock extends HTMLElement {
    constructor() {
      super();

      this.onSubmitListener = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmitListener);
    }

    attachEvents() {
      this.form?.addEventListener('submit', this.onSubmitListener);

      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this)
      );
    }

    handleVariantChange({data}) {
      this.updateVariantId(data.variant.id);
      this.restore();
    }

    init() {
      this.form = this.querySelector('[data-form]');
    }

    restore() {
      this.classList.remove('is-success');
    }

    onSubmit(event) {
      event.preventDefault();

      event.submitter.setAttribute('aria-disabled', 'true');
      event.submitter.setAttribute('aria-busy', 'true');

      const formData = new FormData(this.form);
      const formObject = {};

      formData.forEach((value, key) => {
        formObject[key] = value;
      });

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: formObject.email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${formObject.variant}`
              }
            }
          }
        }
      };

      const config = theme.utils.fetchConfig('json');
      config.headers['Revision'] = '2024-06-15';

      config.body = JSON.stringify(payload);

      fetch(this.form.action, config)
        .then((response) => {
          if (response.ok) {
            this.classList.add('is-success');
          } else {
            return response.text().then(text => {
              throw new Error(`${response.status} ${text}`);
            });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          event.submitter.removeAttribute('aria-busy');
        });
    }

    updateVariantId(variantId) {
      const variantIdField = this.querySelector('input[name="variant"]');

      if (!variantIdField || !variantId) {
        return;
      }

      variantIdField.value = variantId;
    }
  }

  customElements.define('back-in-stock', BackInStock);
})();
